import { array } from 'prop-types';
import "toastr/build/toastr.min.css";
import { toast } from 'react-toastify';
import { QUESTION_TYPE, REQUIRED } from '../config/apiEndPoint';
import { GET, POST, PUT } from 'config/api.config';

export const getQuestionTypeList = async (data = array()) => {
    try {
        let url = data?._Id ? `${QUESTION_TYPE.GET_QUESTION_TYPE_LIST}/${data?._Id}` : `${QUESTION_TYPE.GET_QUESTION_TYPE_LIST}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(response.message);
        // console.log(error);
    }
};

export const addQuestionType = async (data = array()) => {
    try {
        const response = await POST(QUESTION_TYPE.GET_QUESTION_TYPE_LIST, data);
        return response;
    } catch (error) {
        toast.error(error.message);
    }
};

export const updateQuestionType = async (id, data = array()) => {
    try {
        // in api end point page there have a contact us object where mentioned the end point of api
        const url = `${QUESTION_TYPE.GET_QUESTION_TYPE_LIST}/${id}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const getQuestionTypeDataById = async (data = array()) => {
    try {
        let url = data?.Id ? `${QUESTION_TYPE.GET_QUESTION_TYPE_LIST}/${data?.Id}` : `${QUESTION_TYPE.GET_QUESTION_TYPE_LIST}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(response.message);
        // console.log(error);
    }
};

export const getAllQuestionsUsingQuestionTypeId = async (data = array()) => {
    try {
        let url = data?.Id ? `${QUESTION_TYPE.GET_ALL_QUESTIONS}/${data?.Id}` : `${QUESTION_TYPE.GET_ALL_QUESTIONS}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(response.message);
        // console.log(error);
    }
};

export const fetchQuestionTypeTableAndFilterSchema = async (data = array()) => {
    try {
        let url = data?._Id ? `${QUESTION_TYPE.GET_QUESTION_TYPE_SCHEMA}/${data?._Id}` : `${QUESTION_TYPE.GET_QUESTION_TYPE_SCHEMA}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(response.message);
        // console.log(error);
    }
};

export const submitQuestionTypeFilterData = async (data = array()) => {
    try {
        const response = await POST(QUESTION_TYPE.SUBMIT_FILTER_DATA, data);
        return response;
    } catch (error) {
        toast.error(error.message);
    }
};

export const addSingleQuestion = async (data = array()) => {
    try {
        const response = await POST(QUESTION_TYPE.GET_ALL_QUESTIONS, data);
        return response;
    } catch (error) {
        toast.error(error.message);
    }
};

export const updateSingleQuestion = async (id, data = array()) => {
    try {
        // in api end point page there have a contact us object where mentioned the end point of api
        const url = `${QUESTION_TYPE.GET_ALL_QUESTIONS}/${id}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

